// ─────────────────────────────────────────────────────────────────────────────
// icons.js — the stroked SVG glyphs this page draws inline. They inherit
// `currentColor`, so the KPI tile's accent colours them.
// ─────────────────────────────────────────────────────────────────────────────

const glyph = (children) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    {children}
  </svg>
);

export const UsersIcon = () => glyph(
  <>
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87" />
    <path d="M16 3.13a4 4 0 010 7.75" />
  </>
);

export const ClockIcon = () => glyph(
  <>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </>
);

export const ServerIcon = () => glyph(
  <>
    <rect x="2" y="2"  width="20" height="8" rx="2" />
    <rect x="2" y="14" width="20" height="8" rx="2" />
    <line x1="6" y1="6"  x2="6.01" y2="6" />
    <line x1="6" y1="18" x2="6.01" y2="18" />
  </>
);

export const PulseIcon = () => glyph(
  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
);

export const ShieldIcon = () => glyph(
  <>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </>
);

/** The small trend arrow on a KPI tile — flipped vertically when negative. */
export function TrendIcon({ down }) {
  return (
    <svg
      width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor"
      strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"
      style={down ? { transform: "scaleY(-1)" } : undefined}
    >
      <polyline points="1 8.5 4.75 4.75 6.75 6.75 11 3.5" />
      <polyline points="8 3.5 11 3.5 11 6.5" />
    </svg>
  );
}
